const listeners = new Set<() => void>();

/** Ask mounted employee lists to reload after a status change. */
export function notifyEmployeesChanged() {
  listeners.forEach(listener => listener());
}

export function subscribeEmployeesChanged(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
